import Employees from "../../../jsx/components/Dashboard/Employee/Employees";

const EmployeesWrapper = () => {
  return <Employees />;
};

export default constore(EmployeesWrapper);
